
import React from "react";
import {IChannelComponents, IChannelComponentsWrapper} from "../interfaces";


export interface IChannelComponentsProps {
    channelComponentsWrapper?:IChannelComponentsWrapper
}
/**
 * the entry point
 */
const TabChannelComponentsMobile = (props?: IChannelComponentsProps) => {

    const channelComponentsWrapper = props?.channelComponentsWrapper;
    const cc = channelComponentsWrapper?.channelComponents[0];

    const getSurroundComments = (item? : IChannelComponents) => {


        if(item?.comps14)
            return <li>Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad</li>;

        if(item?.comps15)
            return <li>"Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>;

        if(item?.comps16)
            return <li>"Mono<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>;

        if(item?.comps24)
            return <li>Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>;

        if(item?.comps25)
            return <li>Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>;

        if(item?.comps26)
            return <li>Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>;

        if(item?.comps28)
            return <li>Stereo<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1&nbsp;&nbsp;</li>;

        if(item?.comps4)
            return <li>Quad&nbsp;&nbsp;</li>;

        if(item?.comps42)
            return <li>Quad<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>;

        if(item?.comps52)
            return <li>5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>;

        if(item?.comps54)
            return <li>5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>;

        if(item?.comps55)
            return <li>5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.0&nbsp;&nbsp;</li>;

        if(item?.comps56)
            return <li>5.0<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>;

        if(item?.comps62)
            return <li>5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>;

        if(item?.comps64)
            return <li></li>;

        if(item?.comps14)
            return <li>5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>;

        if(item?.comps66)
            return <li>5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>;

        if(item?.comps68)
            return <li>5.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1&nbsp;&nbsp;</li>;

        if(item?.comps82)
            return <li>7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Stereo&nbsp;&nbsp;</li>;

        if(item?.comps84)
            return <li>7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>Quad&nbsp;&nbsp;</li>;

        if(item?.comps86)
            return <li>7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>5.1&nbsp;&nbsp;</li>;

        if(item?.comps88)
            return <li>7.1<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>7.1</li>;

        if(item?.compsAmbiXFuMa)
            return <li>AmbiX<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>FuMa&nbsp;&nbsp;</li>;

        if(item?.compsFuMaAmbiX)
            return <li>FuMa<span style={{padding:"0 1px",fontFamily:"verdana"}}>&#187;</span>AmbiX&nbsp;&nbsp;</li>;

        if(item?.chCompComment)
            return <li><br/><div className="w-full" dangerouslySetInnerHTML={{__html: item?.chCompComment}}/></li>;
    };

    return (
        <div className="my-4">
            {channelComponentsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: channelComponentsWrapper?.topBanner }} />}
            {channelComponentsWrapper != null && channelComponentsWrapper.channelComponents.length > 0 &&
                <ul className="bullet">
                {cc?.compsMono && <li>Mono</li>}
                {cc?.compsStereo && <li>Stereo</li>}
                {cc?.compsMS && <li>Mono-to-Stereo</li>}
                {getSurroundComments(cc)}
            </ul>}

            {channelComponentsWrapper != null && <div className={"my-4"} dangerouslySetInnerHTML={{ __html: channelComponentsWrapper?.bottomBanner }} />}
        </div>
    )
};

export default TabChannelComponentsMobile;